// extracted by mini-css-extract-plugin
export var modal = "_fy-0";